<div id="no_access" *ngIf="proVersion == 'false'">
  <div class="no_access_image">
    <img src="assets/image/pomodoro-illustration.svg" alt="No Access">
  </div>
  <div class="no_access_title">
    برای استفاده از این قابلیت، باید حساب کاربری خود را ارتقاء دهید!
  </div>
  <div class="no_access_cta">
    <a style="cursor: pointer" [routerLink]="['/pricing']">ارتقاء حساب کاربری</a>
  </div>
</div>

<div id="main_app" class="container-fluid" *ngIf="proVersion == 'true'">
  <div class="container">
    <div class="main_chart">
      <div class="main_chart_title">{{ 'WeeklyComparisonChart' | translate }}</div>
      <div class="main_chart_description">
        {{ 'WeeklyComparisonChartDescription' | translate }}
      </div>
      <div>
        <div style="display: block" *ngIf="langMode === 'fa'">
          <canvas id="bar" baseChart
                  [datasets]="barChartData"
                  [labels]="barChartLabelsFarsi"
                  [options]="barChartOptions"
                  [plugins]="barChartPlugins"
                  [legend]="barChartLegend"
                  [colors]="chartColors"
                  [chartType]="barChartType">
          </canvas>
        </div>
        <div style="display: block" *ngIf="langMode === 'en'">
          <canvas id="barEn" baseChart
                  [datasets]="barChartData"
                  [labels]="barChartLabelsEnglish"
                  [options]="barChartOptions"
                  [plugins]="barChartPlugins"
                  [legend]="barChartLegend"
                  [colors]="chartColors"
                  [chartType]="barChartType">
          </canvas>
        </div>
      </div>
      <div class="row">
        <table class="table">
          <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">{{ 'Saturday' | translate }}</th>
            <th scope="col">{{ 'Sunday' | translate }}</th>
            <th scope="col">{{ 'Monday' | translate }}</th>
            <th scope="col">{{ 'Tuesday' | translate }}</th>
            <th scope="col">{{ 'Wednesday' | translate }}</th>
            <th scope="col">{{ 'Thursday' | translate }}</th>
            <th scope="col">{{ 'Friday' | translate }}</th>
            <th scope="col">{{ 'TotalAverage' | translate }}</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <th scope="row">
              <div class="the-row">
                {{ 'LastWeek' | translate }}
                <div class="last-week-circle"></div>
              </div>
            </th>
            <td *ngFor="let i of lastWeek">{{i}}</td>
            <td>{{lastsWeekTotalAverage}}</td>
          </tr>
          <tr>
            <th scope="row">
              <div class="the-row">
                {{ 'ThisWeek' | translate }}
                <div class="this-week-circle"></div>
              </div>
            </th>
            <td *ngFor="let i of thisWeek">{{i}}</td>
            <td>{{thisWeekTotalAverage}}</td>
          </tr>
          <tr>
            <th scope="row">
              <div class="the-row">
                {{ 'TotalAverage' | translate }}
                <div class="average-week-circle"></div>
              </div>
            </th>
            <td *ngFor="let i of average">{{i}}</td>
            <td>{{averageTotalAverage}}</td>
          </tr>
          </tbody>

        </table>
      </div>
    </div>
    <div class="main_chart">
      <div class="main_chart_title">{{ 'TimeChartInTermsOfCategories' | translate }}</div>
      <div class="main_chart_description">
        {{ 'TimeChartInTermsOfCategoriesDescription' | translate }}
      </div>
      <div class="second-chart">
        <div class="chart-btn">
          <ul>
            <li (click)="onClick(3)" [ngClass]="{'active': tab==='tab3'}">
              <a (click)="getWeekDoughtChart()">{{ 'Week' | translate }}</a>
            </li>
            <li (click)="onClick(2)" [ngClass]="{'active': tab==='tab2'}">
              <a (click)="getMonthDoughtChart()">{{ 'Month' | translate }}</a>
            </li>
            <li (click)="onClick(1)" [ngClass]="{'active': tab==='tab1'}">
              <a (click)="getYearDoughtChart()">{{ 'Year' | translate }}</a>
            </li>
          </ul>
          <div class="clearfix"></div>
        </div>
        <div class="doughnut">
          <canvas baseChart style="display: block; width: 500px; height: 500px"
                  [data]="doughnutChartData"
                  [labels]="doughnutChartLabels"
                  [colors]="pieChartColors"
                  [chartType]="doughnutChartType">
          </canvas>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
    <div class="main_chart">
      <div class="main_chart_title">{{ 'MonthlyChart' | translate }}</div>
      <div class="main_chart_description">
        {{ 'MonthlyChartDescription' | translate }}
      </div>
      <div>
        <div style="display: block;" *ngIf="langMode === 'fa'">
          <canvas baseChart width="400" height="100"
                  [datasets]="lineChartData"
                  [labels]="lineChartLabelsFarsi"
                  [options]="lineChartOptions"
                  [colors]="lineChartColors"
                  [legend]="lineChartLegend"
                  [chartType]="lineChartType"
                  [plugins]="lineChartPlugins">
          </canvas>
        </div>
        <div style="display: block;" *ngIf="langMode === 'en'">
          <canvas baseChart width="400" height="100"
                  [datasets]="lineChartData"
                  [labels]="lineChartLabelsEnglish"
                  [options]="lineChartOptions"
                  [colors]="lineChartColors"
                  [legend]="lineChartLegend"
                  [chartType]="lineChartType"
                  [plugins]="lineChartPlugins">
          </canvas>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
